import script from "./lyabout.vue?vue&type=script&setup=true&lang=js"
export * from "./lyabout.vue?vue&type=script&setup=true&lang=js"

import "./lyabout.vue?vue&type=style&index=0&id=18865a01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18865a01"]])

export default __exports__